// src/constants.js — Design tokens
export const G  = '#F5C518';
export const GD = '#C9960C';
export const GL = '#FFE066';

// ── Item rarity — ONE canonical source (S-160) ───────────────────────────────
// WHY THIS EXISTS: RARITY_COLORS was copy-pasted into 4 webapp files and 4 mobile
// files, RARITY_GLOW into 2 more, plus an inline ternary in StorePage. SIX of those
// copies had no `uncommon` key at all — while the DB seeds 68 uncommon rows
// (stickers, auras, flags, avatars, emojis). Call sites also disagreed on the
// fallback ('#888' / 'none' / G / '#333'), and AuctionPage.jsx:66-67 had NO
// fallback, rendering `color: undefined` and `1px solid undefined`.
//
// USE rarityColor()/rarityGlow(), NOT the raw maps — then an unknown rarity can
// never render `undefined` again.
//
// The hexes are deliberately LITERAL, not derived from theme tokens: `rare` is
// #4B8BF5, which is NOT the mobile theme's BLUE (#6B8DE3). Deriving would have
// silently recoloured every rare item in the app.
//
// NOT MERGED HERE ON PURPOSE: GamificationPage.jsx has its own rarity map
// (legendary/mythic/elite/rare/uncommon). That is CHALLENGE-tier taxonomy, a
// different domain from shop-item rarity. Merging them would be a bug.
export const RARITY_COLORS = {
  legendary: '#FFD700',
  epic:      '#B26BFF',
  rare:      '#4B8BF5',
  uncommon:  '#0ECB81',
  common:    '#888',
};

// Glow is webapp-only: these are CSS box-shadow strings, which React Native
// cannot consume. Mobile gets colours only — same outcome, native idiom (Rule Q).
// `uncommon` follows the established descending ramp: 16px → 12px → 8px → 6px → none.
export const RARITY_GLOW = {
  legendary: '0 0 16px #FFD70066',
  epic:      '0 0 12px #B26BFF44',
  rare:      '0 0 8px #4B8BF533',
  uncommon:  '0 0 6px #0ECB8133',
  common:    'none',
};

export const RARITY_FALLBACK = '#888';

// fallback is overridable because two sites legitimately want a non-grey default
// (UserAvatar falls back to gold, AuctionPage card border to '#333').
export function rarityColor(rarity, fallback = RARITY_FALLBACK) {
  return RARITY_COLORS[rarity] || fallback;
}

export function rarityGlow(rarity) {
  return RARITY_GLOW[rarity] || 'none';
}
